import { render, staticRenderFns } from "./EditRolesDialog.vue?vue&type=template&id=6ed395b9&"
import script from "./EditRolesDialog.vue?vue&type=script&lang=js&"
export * from "./EditRolesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports